import { product } from './product.js';
import { initWindows, setInitialPositions, openWindow, openInitialWindows } from './windows.js';
import { initMenu } from './menu.js';
import { initCart } from './cart.js';
import { initEffects, typeInfosText, initCDHover, initInfosAutoScroll } from './effects.js';

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function preloadImages() {
  return Promise.all(
    ['cd-cover-img', 'backcover-img']
      .map(id => document.getElementById(id))
      .filter(Boolean)
      .map(img => img.decode().catch(() => {}))
  );
}

function populateProduct() {
  const priceEl = document.getElementById('buy-price');
  if (priceEl) priceEl.textContent = `${product.price} ${product.currency}`;

  // Set img sources from product data (never hardcoded in HTML)
  const coverImg     = document.getElementById('cd-cover-img');
  const backcoverImg = document.getElementById('backcover-img');
  if (coverImg)     coverImg.src     = product.cover;
  if (backcoverImg) backcoverImg.src = product.backcover;
}

// ── Lightbox ──────────────────────────────────────────────────────────────
// Les éléments sont résolus à chaque appel (jamais capturés en closure) :
// l'éditeur de thème Shopify remplace le DOM de la section à chaque réglage.

function openLightbox(src, alt) {
  const lightbox    = document.getElementById('lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  if (!lightbox || !lightboxImg) return;

  lightboxImg.src = src;
  lightboxImg.alt = alt;
  lightbox.classList.remove('lightbox--anim-close');
  lightbox.classList.add('lightbox--open');
  lightbox.removeAttribute('aria-hidden');
  if (!reducedMotion) {
    void lightbox.offsetWidth;
    lightbox.classList.add('lightbox--anim-open');
    setTimeout(() => lightbox.classList.remove('lightbox--anim-open'), 280);
  }
}

function closeLightbox() {
  const lightbox = document.getElementById('lightbox');
  if (!lightbox || !lightbox.classList.contains('lightbox--open')) return;

  if (reducedMotion) {
    lightbox.classList.remove('lightbox--open');
    lightbox.setAttribute('aria-hidden', 'true');
    return;
  }
  lightbox.classList.remove('lightbox--anim-open');
  lightbox.classList.add('lightbox--anim-close');
  lightbox.classList.remove('lightbox--open');
  setTimeout(() => {
    lightbox.classList.remove('lightbox--anim-close');
    lightbox.setAttribute('aria-hidden', 'true');
  }, 220);
}

// Handler nommé : addEventListener dédoublonne les re-binds sur document
function onLightboxKey(e) {
  if (e.key === 'Escape') closeLightbox();
}

function initLightbox() {
  const lightbox      = document.getElementById('lightbox');
  const lightboxClose = document.getElementById('lightbox-close');
  const backcoverImg  = document.getElementById('backcover-img');
  const coverImg      = document.getElementById('cover-img');

  if (backcoverImg) backcoverImg.addEventListener('click', () => openLightbox(product.backcover, `${product.title} — Backcover`));
  if (coverImg)     coverImg.addEventListener('click', () => openLightbox(product.cover, `${product.title} — Cover`));
  lightboxClose.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', e => { if (e.target === lightbox) closeLightbox(); });

  document.addEventListener('keydown', onLightboxKey);
}

function watchInfosWindow() {
  const win = document.getElementById('win-infos');
  if (!win) return;

  if (!win.classList.contains('window--hidden')) {
    setTimeout(typeInfosText, 500);
  }

  new MutationObserver(() => {
    if (!win.classList.contains('window--hidden')) typeInfosText();
  }).observe(win, { attributes: true, attributeFilter: ['class'] });
}

function initArchives() {
  // Le layout charge ce script sur toutes les pages ; la section archives-main
  // n'existe que sur les templates index/product.
  if (!document.getElementById('stage')) return;

  populateProduct();
  initWindows();
  setInitialPositions();
  openInitialWindows();
  initMenu();
  initCart();
  initEffects();
  initCDHover();
  initInfosAutoScroll();
  initLightbox();
  watchInfosWindow();
}

document.addEventListener('DOMContentLoaded', initArchives);

// Éditeur de thème Shopify : chaque changement de réglage re-rend la section
// en AJAX (nouveau DOM, fenêtres à l'état initial window--hidden) sans
// re-déclencher DOMContentLoaded → on ré-initialise tout sur le nouveau DOM.
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', e => {
    if (e.target.querySelector('#stage')) initArchives();
  });
}
